module.exports = __webpack_public_path__ + "img/v6.e954e37b.jpg";